<template>
  <div>
    <el-tabs v-model="activeName" @tab-click="handleClick">
      <el-tab-pane :label="$t('app.userAccount.tabs.rechargeDetails')" name="first" v-if="checkPermi(['person:userAccount:recharge'])">
        <rechargeList ref="rechargeListRef"></rechargeList>
      </el-tab-pane>
      <el-tab-pane :label="$t('app.userAccount.tabs.expendDetails')" name="second" v-if="checkPermi(['person:userAccount:expend'])">
        <payList ref="payListRef"></payList>
      </el-tab-pane>
      <el-tab-pane :label="$t('app.userAccount.tabs.autoRenewal')" name="third" v-if="checkPermi(['person:userAccount:renewal'])">
        <renewList ></renewList>
      </el-tab-pane>
      <el-tab-pane :label="$t('app.userAccount.tabs.agentBalance')" name="fourth" v-if="checkPermi(['person:userAccount:balance'])">
        <agentBalanceList ref="agentBalanceListRef"></agentBalanceList>
      </el-tab-pane>
    </el-tabs>
  </div>
</template>
<script>
import rechargeList from "@/components/accountComponets/rechargeList.vue";
import payList from "@/components/accountComponets/payList.vue";
import renewList from "@/components/accountComponets/renewList.vue";
import agentBalanceList from "@/components/accountComponets/agentBalanceList.vue";
export default {
  data() {
    return {
      activeName: "first",
    };
  },
  components: {
    rechargeList,
    renewList,
    payList,
    agentBalanceList
  },
  computed: {
    adminShow() {
      return this.$store.getters.user.userType =='1'
    }
  },
  methods: {
    handleClick(tab) {
      if (tab.name == "first") {
        this.$refs.rechargeListRef.initData();
      } else if (tab.name == "second") {
        this.$refs.payListRef.initData();
      }else if (tab.name == "fourth") {
        this.$refs.agentBalanceListRef.initData();
      }
    },
  },
  created() {
  },
  mounted() {
    
  },
};
</script>
<style scoped lang="less">

</style>  